export function calculTauxMarge(product) {
    if(product.mf_price_public && product.paht){
        return Math.round(((product.mf_price_public - product.paht) / product.mf_price_public * 100) * 100) / 100 + ' %';
    }else{
        return 'NR';
    }
}
